import { createRecipe } from './runtime.mjs';

const iconButtonConfig = {"name":"iconButton","className":"ds-icon-button","defaultVariants":{"color":"secondary","size":"md","variant":"filled"},"variantMap":{"variant":["filled","ghost"],"color":["primary","secondary","success","error","warning","info","brand","inverse","black","white","alert"],"size":["xs","sm","md","lg","xl","2xl"]}}

export const iconButton = /* @__PURE__ */ createRecipe(iconButtonConfig)